import { Tag } from '@blueprintjs/core';

interface Props {
  text: string;
}

export function FilterAppliedIndicator({ text }: Props) {
  return (
    <Tag minimal intent="none">
      {text}
    </Tag>
  );
}
